<template>
    <div class="template-download">
        <h5>{{ name }}</h5>
        <div class="btns">
            <el-button :loading="loading" :disabled="url ? false : true" @click="onDownLoad()" size="mini">下载模板</el-button>
            <p class="tips">{{ tips }}</p>
        </div>
    </div>
</template>
<script>
import { downLoadByUri } from '@/api/file';
export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        },
        tips: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async onDownLoad() {
            try {
                this.loading = true;
                await downLoadByUri(this.url, this.name);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.$message.error('委托授权书模版下载失败，请稍后尝试');
            }
        }
    }
};
</script>

<style lang="scss">
.template-download {
    padding: 30px 20px;
    background: $--background-secondary;

    h5 {
        color: $--color-font-normal;
        font-weight: 600;
        color: #303133;
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 20px;
    }

    .btns {
        display: flex;

        .tips {
            margin-left: 10px;
            color: $--color-font-text;
            font-size: 12px;
        }
    }
}
</style>
